<template>
  <div>
    <div class="productBanner"><Banner :classType="2" /></div>
    <Menu />

    <div
      class="pageTitle wow animate__slideInUp"
      :class="{ titleEn: lang == 'en' }"
    >
      <h2>产品介绍</h2>
      <p>PRODUCTS</p>
    </div>

    <div class="grey-bg productS wow animate__slideInUp">
      <div class="wrap productTwo">
        <el-row :gutter="50">
          <el-col :xs="24" :sm="24" :md="11"
            ><el-image
              :src="intro.PicUrl"
              fit="cover"
              class="productImg"
            ></el-image
          ></el-col>
          <el-col :xs="24" :sm="24" :md="13" class="productTxt">
            <p v-html="intro.Summary"></p>
          </el-col>
        </el-row>
      </div>
    </div>

    <div
      class="proTit wow animate__slideInUp"
      :class="{ titleEn: lang == 'en' }"
    >
      {{
        lang == "zh"
          ? "中复神鹰碳纤维主要型号"
          : "Main Fiber Models of Zhongfu Shenying"
      }}
    </div>

    <div class="wrap productIpd wow animate__slideInUp">
      <el-table :data="NewProductInfos">
        <el-table-column
          :prop="`Item${idx + 1}`"
          :label="item"
          :key="idx"
          v-for="(item, idx) in Names"
        >
          <template slot="header" slot-scope="scope"
            ><span v-html="changeValue(item)"></span
          ></template>
          <template slot-scope="scope">
            <div v-html="changeValue(scope.row[`${idx}`])"></div>
          </template>
        </el-table-column>
      </el-table>
      <div class="">
        <Pagination @pageChange="getList" :PagingInfo="PagingInfo2" />
      </div>
    </div>

<div v-if="lang=='en'">
    <div
      class="pageTitle wow animate__slideInUp"
      ref="two"
      :class="{ titleEn: lang == 'en' }" 
    >
      <h2>品质认证</h2>
      <p>QUALITY ASSURANCE</p>
    </div>

    <div class="wrap productIbox wow animate__slideInUp">
      <NewsList
        :actionTxt="lang == 'zh' ? 资料下载 : 'View'"
        :newsList="newsList"
        down="down"
      />
    </div>
    <div class="pageBox">
      <Pagination @pageChange="getData" :PagingInfo="PagingInfo" />
    </div>
  </div>
  </div>
</template>

<script>
import Menu from "./Menu.vue";
import Banner from "@/views/components/Banner";
import NewsList from "@/views/components/NewsList";
import Pagination from "@/views/components/Pagenation";
import { changeText } from "@/utils/tool";
import { WOW } from "wowjs";

export default {
  data() {
    return {
      type: this.$route.query.type || "",
      tableData: [
        {
          one: "SYT45",
          two: ["3K"],
          three: ["≥4000"],
          four: ["220~260"],
          five: ["198"],
          six: "≥1.5",
          seven: "7",
          eight:"1"
        },
        {
          one: "SYT45S",
          two: ["12K", "24K"],
          three: ["≥4900", "≥4900"],
          four: ["220~260", "220~260"],
          five: ["800", "1600"],
          six: "≥1.7",
          seven: "7",
          eight:"1"
        },
        {
          one: "SYT49S",
          two: ["12K", "24K"],
          three: ["≥4900", "≥4900"],
          four: ["220~260", "220~260"],
          five: ["800", "1600"],
          six: "≥1.8",
          seven: "7",
          eight:"1"
        },
        {
          one: "SYT55",
          two: ["12K"],
          three: ["≥5900"],
          four: ["≥290"],
          five: ["450"],
          six: "≥2.0",
          seven: "5",
          eight:"1"
        },
        {
          one: "SYT55S",
          two: ["12K", "24K"],
          three: ["≥5900", "≥5900"],
          four: ["≥290", "≥290"],
          five: ["450", "900"],
          six: "≥2.0",
          seven: "5",
          eight:"1"
        },
        {
          one: "SYT65",
          two: ["12K"],
          three: ["≥6400"],
          four: ["≥295"],
          five: ["450"],
          six: "≥2.1",
          seven: "5",
          eight:"1"
        },
        {
          one: "SYM30",
          two: ["12K"],
          three: ["≥4500"],
          four: ["≥280"],
          five: ["740"],
          six: "≥1.5",
          seven: "7",
          eight:"1"
        },
        {
          one: "SYM35",
          two: ["12K"],
          three: ["≥4700"],
          four: ["≥330"],
          five: ["450"],
          six: "≥1.4",
          seven: "5",
          eight:"1"
        },
        {
          one: "SYM40",
          two: ["12K"],
          three: ["≥4700"],
          four: ["≥370"],
          five: ["430"],
          six: "≥1.2",
          seven: "5",
          eight:"1"
        },
      ],
      newsList: [],
      PagingInfo: {},
      NewProductInfos:[],
      PagingInfo2: {},
      intro: {},
      lang: "zh",
      Names: [],
    };
  },
  methods: {
    changeValue(value) {
      return changeText(value);
    },
    handleScroll() {
      let two = this.$refs.two.offsetTop - 50;
      let meshine = navigator.userAgent;
      var element =
        meshine.indexOf("Weixin") == -1
          ? document.documentElement
          : document.body;

      element.scrollTop = two;
    },
    getData(page, type) {
      this.$api
        .fileList({
          Type: 1,
          CurrentPage: page,
          ItemsPerPage: 8,
        })
        .then((res) => {
          const { FileInfos, PagingInfo } = res.Value;
          console.log(res,'+++');
          this.newsList = FileInfos;
          this.PagingInfo = PagingInfo;
          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                live: false,
              }).init();
            });
          }
        });
    },
    getList(page) {
      this.$api
        .productList({
          CurrentPage: page,
          ItemsPerPage: 8,
        })
        .then((res) => {         
          const { ProductInfos,NewProductInfos, PagingInfo, Names } = res.Value;
          console.log(res,'999')
          this.NewProductInfos = NewProductInfos;
          this.PagingInfo2 = PagingInfo;
          this.Names = Names;
        });
    },
    getProductIntroduceFN() {
      this.$api.getProductIntroduce().then((res) => {
        this.intro = res.Value;
        if (this.type == "two") {
          this.handleScroll();
        }
      });
    },
  },

  created() {
    this.lang = this.$global.lang;
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // 对路由变化做出响应...
        this.type = this.$route.params.type;
        if (this.type == "two") {
          this.handleScroll();
        }
      }
    );
  },
  mounted() {
    this.type = this.$route.params.type;
    this.getData(1, "first");
    this.getList(1);
    this.getProductIntroduceFN();
    if (this.type == "two") {
      this.handleScroll();
    }
  },
  components: {
    Menu,
    Banner,
    NewsList,
    Pagination,
  },
};
</script>

<style lang="scss">
.productIpd {
  padding-top: 50px;
  .el-table {
    margin-bottom:0!important;
    thead {
      color: #000;
    }
    th,
    td {
      text-align: center;
    }
  }
  .el-table th.el-table__cell {
    background-color: #f9f9f9;
  }
}
.productS {
  margin-top: 50px;
}
.productIbox {
  padding-top: 50px;
}
.proTit {
  text-align: center;
  font-size:24px;
  font-weight: bold;
  color: #000;
  padding: 50px 0 0 0;
}
.productIpd .el-table{
  margin-bottom:25px;
}
.productIpd .el-table thead{
  font-size:16px;
}
.productIpd .el-table td{
  padding:15px 0;
}
</style>